const localizers = {
  'Alerts.noAlerts.txt': () => `ไม่ได้กำหนดการแจ้งเตือนสำหรับรายงานนี้`,
  'BirdImage.image.txt': () => `ภาพ`,
  'BirdText.editable.tooltip.txt': () => `ดับเบิลคลิกเพื่อแก้ไขข้อความ`,
  'ComboBox.clearFilter.txt': () => `ลบตัวกรอง`,
  'ComboBox.defautValueNoData.fmt': ({categoryValue}) => `${categoryValue} (ไม่มีข้อมูล)`,
  'ContextMenu.selectAll.txt': () => `เลือกทั้งหมด`,
  'ContextMenu.clearSelection.txt': () => `ล้างการเลือก`,
  'ContextMenu.exportImage.txt': () => `ส่งออกเป็นภาพ`,
  'ContextMenu.sortAscending.fmt': ({role}) => `${role}: น้อยไปมาก`,
  'ContextMenu.sortDescending.fmt': ({role}) => `${role}: มากไปน้อย`,
  'ContextMenu.sortAddAscending.fmt': ({role}) => `${role}: เพิ่มน้อยไปมาก`,
  'ContextMenu.sortAddDescending.fmt': ({role}) => `${role}: เพิ่มมากไปน้อย`,
  'ContextMenu.removeSortItem.fmt': ({role}) => `นำ ${role} ออกจากการเรียง`,
  'ContextMenu.removeSortLevel.txt': () => `นำระดับการเรียงออก`,
  'ContextMenu.sort.txt': () => `เรียงลำดับ`,
  'ContextMenu.selectShortestPath.txt': () => `เลือกเส้นทางที่สั้นที่สุด`,
  'ContextMenu.explain.txt': () => `อธิบายข้อมูล`,
  'ContextMenu.explainRole.txt': ({role}) => `อธิบาย ${role}...`,
  'ContextMenu.manageColumns.txt': () => `จัดการคอลัมน์`,
  'ContextMenu.includeMissingValues.txt': () => `รวมค่าที่หายไป`,
  'DrillableTooltip.drill.txt': () => `ดูข้อมูล`,
  'DrillableTooltip.tooltip.txt': () => `เคล็ดลับการใช้`,
  'DrillableTooltip.links.txt': () => `ลิงก์`,
  'DrillableTooltip.section.link.fmt': ({page}) => `ลิงค์หน้าไปยัง ${page}`,
  'DrillableTooltip.report.link.fmt': ({report}) => `ลิงค์รายงานไปยัง ${report}`,
  'DrillableTooltip.external.link.fmt': ({url}) => `ลิงค์ภายนอกไปยัง ${url}`,
  'DrillableTooltip.notAvailable.txt': () => `ไม่พร้อมใช้งาน`,
  'Breadcrumb.all.fmt': ({label}) => `ทั้งหมด ${label}`,
  'BrowserCheck.title.txt': () => `ตรวจสอบ WebGL`,
  'BrowserCheck.msg.txt': () => `WebGL ถูกปิดใช้งานหรือเบราว์เซอร์ของคุณไม่รองรับ   \nคลิกตกลงเพื่อดูรายงานในโปรแกรมดูแบบคลาสสิก`,
  'EmailUtil.subject.multiple.txt': () => `รายงานสำหรับตรวจทาน`,
  'EmailUtil.tooLongEmail.txt': () => `ความยาวของอีเมลเกินขีดจำกัด เลือกรายงานที่จะส่งอีเมลน้อยลง`,
  'HiddenSectionDialog.close.txt': () => `ปิด`,
  'HiddenSectionDialog.export.txt': () => `ส่งออกเป็น PDF`,
  'InfoPanel.information.txt': () => `ข้อมูล`,
  'InfoPanel.comments.txt': () => `ความคิดเห็น`,
  'InfoPanel.alerts.txt': () => `การแจ้งเตือน`,
  'IncomingFilters.promptbars.txt': () => `แถบพร้อมท์`,
  'Information.title.txt': () => `ชื่อ`,
  'Information.name.txt': () => `ชื่อ:`,
  'Information.description.txt': () => `คำอธิบาย:`,
  'Information.displayRules.txt': () => `กฎการแสดงผล:`,
  'Information.graphLevel.txt': () => `ระดับกราฟ`,
  'Information.reportLevel.txt': () => `ระดับรายงาน`,
  'Information.legend.txt': () => `คำอธิบายแผนภูมิ`,
  'Information.incomingFilters.txt': () => `ตัวกรองขาเข้า:`,
  'Information.noIncomingFilters.txt': () => `ไม่มีตัวกรองขาเข้า`,
  'Information.dataSourceFilters.txt': () => `ตัวกรองแหล่งข้อมูล:`,
  'Information.interactiveFilters.txt': () => `ตัวกรองแบบอินเทอร์แอ็คทีฟ:`,
  'MobileContainer.mobileBIMessage.txt': () => `เข้าถึงรายงาน SAS บนอุปกรณ์มือถือของคุณ`,
  'ObjectTypes.report.txt': () => `รายงาน`,
  'ObjectTypes.Report.BI.txt': () => `รายงาน SAS (2G)`,
  'ObjectTypes.Report.StoredProcess.txt': () => `รายงานกระบวนการที่จัดเก็บไว้`,
  'ObjectTypes.StoredProcess.txt': () => `กระบวนการที่จัดเก็บไว้`,
  'MissingValues.label.txt': () => `(ค่าที่ขาดหายไป)`,
  'PromptContainer.apply.txt': () => `ตกลง`,
  'PromptContainer.cancel.txt': () => `ยกเลิก`,
  'PromptContainer.close.txt': () => `ปิด`,
  'TextFieldTypeAhead.validation.range.fmt': ({min, max}) => `ค่าจะต้องเป็นตัวเลขที่มีค่าตั้งแต่ ${min} และ ${max} โดยรวม`,
  'TextFieldTypeAhead.validation.numeric.txt': () => `ระบุค่าตัวเลขที่ถูกต้อง`,
  'TextFieldTypeAhead.validation.string.txt': () => `ค่าไม่ถูกต้องสำหรับข้อมูลที่กำหนดไว้`,
  'TextFieldTypeAhead.categoryAndMeasureTooltip.fmt': ({categoryLabel, measureLabel}) => `ป้อน: ${categoryLabel}, ${measureLabel}`,
  'TextFieldTypeAhead.categoryTooltip.fmt': ({categoryLabel}) => `ป้อน: ${categoryLabel}`,
  'TextFieldTypeAhead.placeholder.fmt': ({placeholderLabel}) => `ป้อน: ${placeholderLabel}…`,
  'RangeSlider.tooltip.fmt': ({label, min, max}) => `${label}: ${min} - ${max}`,
  'Slider.missingValues.txt': () => `ค่าที่หายไป`,
  'PromptElement.categoryLabelValueAndMeasureLabelValueTooltip.fmt': ({categoryLabel, categoryValue, measureLabel, measureValue}) => `${categoryLabel}: ${categoryValue}, ${measureLabel}: ${measureValue}`,
  'PromptElement.categoryLabelValueTooltip.fmt': ({categoryLabel, categoryValue}) => `${categoryLabel}: ${categoryValue}`,
  'ReportContainer.back.txt': () => `ย้อนกลับ`,
  'ReportContainer.reportCorrupted.txt': () => `รายงานเสียหาย`,
  'ReportContainer.themeLoadFailed.txt': () => `ไม่สามารถโหลดธีมของรายงาน`,
  'ReportContainer.restoreButton.tip.txt': () => `กู้คืนรายงาน`,
  'ReportContainer.restoreButtonAriaAnnounce.txt': () => `รายงานกู้คืนแล้ว`,
  'ReportContainer.renderError.txt': () => `เกิดข้อผิดพลาด ไม่สามารถแสดงรายงานได้`,
  'ReportContainer.component.renderError.txt': () => `เกิดข้อผิดพลาด ไม่สามารถแสดงคอมโนเนนต์ได้`,
  'ReportContentPage.open.txt': () => `เปิด…`,
  'ReportContentPage.refreshReport.txt': () => `รีเฟรชรายงาน`,
  'ReportContentPage.editReport.txt': () => `แก้ไขรายงาน`,
  'ReportContentPage.print.txt': () => `พิมพ์…`,
  'ReportContentPage.email.txt': () => `อีเมล…`,
  'ReportContentPage.export.txt': () => `ส่งออกไปยัง Excel…`,
  'ReportContentPage.reportProperties.txt': () => `คุณสมบัติรายงาน`,
  'ReportContentPage.shareReport.txt': () => `แชร์รายงาน`,
  'ReportContentPage.enableOverlays.txt': () => `เปิดใช้งานการวางซ้อนอ็อบเจ็กต์`,
  'ReportContentPage.disableOverlays.txt': () => `ปิดใช้งานการวางซ้อนอ็อบเจ็กต์`,
  'ReportContentPage.link.txt': () => `ลิงก์…`,
  'ReportContentPage.settings.txt': () => `การตั้งค่า…`,
  'ReportContentPage.editPlayback.txt': () => `แก้ไขการเล่น`,
  'ReportContentPage.playReport.txt': () => `รายงานการเล่น`,
  'ReportContentPage.showFiltersButton.tip.txt': () => `แสดงตัวกรองที่แจ้งเตือน`,
  'ReportContentPage.hideFiltersButton.tip.txt': () => `ซ่อนตัวกรองที่แจ้งเตือน`,
  'ReportContentPage.reportFilters.txt': () => `ระดับรายงาน`,
  'ReportContentPage.pageFilters.txt': () => `ระดับหน้า`,
  'ReportContentPage.refreshRequired.txt': () => `ไม่จำเป็นต้องรีเฟรชรายงาน`,
  'ReportContentPage.infoButton.tip.txt': () => `แผงข้อมูล`,
  'ReportContentPage.backButton.tip.txt': () => `ดูรายงานทั้งหมด`,
  'ReportContentPage.overflowMenuButton.tip.txt': () => `ตัวเลือกเพิ่มเติม`,
  'ReportContentPage.itemGroupName.txt': () => `รายงาน`,
  'ReportContentPage.maximizeButton.tip.txt': () => `ขยายรายงานใหญ่ที่สุด`,
  'ReportContentPage.closeButton.txt': () => `ปิดรายงาน`,
  'ReportContentPage.maximizeButtonAriaAnnounce.txt': () => `รายงานขยายใหญ่ที่สุด`,
  'ReportContentPage.resetReportState.txt': () => `คืนค่าสถานะรายงานเริ่มต้น`,
  'ReportContentPage.summary.txt': () => `แสดงบทสรุป`,
  'ReportManagerPage.objectMenu.open.txt': () => `เปิด`,
  'ReportManagerPage.objectMenu.edit.txt': () => `แก้ไข`,
  'ReportManagerPage.objectMenu.summary.txt': () => `สรุป`,
  'ReportManagerPage.objectMenu.properties.txt': () => `คุณสมบัติ`,
  'ReportManagerPage.objectMenu.email.txt': () => `อีเมล…`,
  'ReportManagerPage.objectMenu.print.txt': () => `พิมพ์`,
  'ReportManagerPage.browseReportsButton.txt': () => `เรียกดูรายงาน`,
  'ReportManagerPage.newReportButton.txt': () => `รายงานใหม่`,
  'ReportManagerPage.emptyView.message.txt': () => `ไม่พบรายงาน`,
  'ReportManagerPage.emptyView.browseReportsButton.txt': () => `เรียกดูรายงาน`,
  'ReportManagerPage.tableView.name.txt': () => `ชื่อ`,
  'ReportManagerPage.tableView.author.txt': () => `ผู้สร้าง`,
  'ReportManagerPage.tableView.lastModified.txt': () => `เปลี่ยนแปลงล่าสุด`,
  'ReportManagerPage.openButton.tip.txt': () => `เปิดรายงาน`,
  'ReportManagerPage.emailButton.tip.txt': () => `รายงานทางอีเมล`,
  'ReportManagerPage.printButton.tip.txt': () => `พิมพ์รายงานไปยัง PDF`,
  'ReportManagerPage.propertiesButton.tip.txt': () => `คุณสมบัติรายงาน`,
  'ReportObject.multipleReferences.error.txt': () => `ไม่สามารถใช้วัตถุรายงานในหลายบริบทได้`,
  'ReportObject.notFound.error.txt': () => `ไม่พบชื่อวัตถุในรายงานที่ระบุ`,
  'ReportObject.invalidPage.error.txt': () => `หน้าที่ระบุไม่ถูกต้อง`,
  'ReportPropertiesDialog.open.txt': () => `เปิด`,
  'ReportPropertiesDialog.close.txt': () => `ปิด`,
  'ReportPropertiesDialog.name.txt': () => `ชื่อ:`,
  'ReportPropertiesDialog.description.txt': () => `คำอธิบาย:`,
  'ReportPropertiesDialog.keywords.txt': () => `คำหลัก:`,
  'ReportPropertiesDialog.type.txt': () => `ประเภท:`,
  'ReportPropertiesDialog.location.txt': () => `ตำแหน่งที่ตั้ง:`,
  'ReportPropertiesDialog.createdBy.txt': () => `สร้างโดย:`,
  'ReportPropertiesDialog.dateCreated.txt': () => `วันที่สร้าง:`,
  'ReportPropertiesDialog.modifiedBy.txt': () => `เปลี่ยนแปลงโดย:`,
  'ReportPropertiesDialog.dateModified.txt': () => `วันที่เปลี่ยนแปลง:`,
  'ReportSections.newPageButton.txt': () => `หน้าใหม่`,
  'ReportSections.closeTab.tooltip.txt': () => `ลบหน้า`,
  'ReportSections.menuButton.tooltip.fmt': ({label}) => `เมนู ${label}`,
  'ReportSummaryDialog.title.txt': () => `สรุป`,
  'ReportSummaryDialog.open.txt': () => `เปิด`,
  'ReportSummaryDialog.cancel.txt': () => `ยกเลิก`,
  'ReportSummaryDialog.close.txt': () => `ปิด`,
  'ReportSummaryDialog.noSummary.txt': () => `ไม่มีสรุป`,
  'ReportTileBody.modifiedBy.txt': () => `เปลี่ยนแปลงโดย:`,
  'ReportTileBody.lastModified.txt': () => `เปลี่ยนแปลงล่าสุด:`,
  'VAViewerSettingsProvider.reportViewer.txt': () => `โปรแกรมดูรายงาน SAS`,
  'VAViewerSettingsProvider.reportRefreshSettings.txt': () => `รีเฟรชรายงาน`,
  'VAViewerSettingsProvider.reportAutoRefresh.txt': () => `รีเฟรชรายงานอัตโนมัติ`,
  'VAViewerSettingsProvider.reportRefreshFrequency.txt': () => `ตรวจดูการอัพเดตหลังจากผ่านไปตามนาทีต่อไปนี้:`,
  'VAViewerSettingsProvider.alert.group.label.txt': () => `การแจ้งเตือน`,
  'VAViewerSettingsProvider.alert.field.label.txt': () => `เลือกการแจ้งเตือนเริ่มต้น:`,
  'VAViewerSettingsProvider.alert.email.txt': () => `ส่งข้อความอีเมล`,
  'VAViewerSettingsProvider.alert.sms.txt': () => `ส่งข้อความ SMS`,
  'VAViewerSettingsProvider.alert.system.txt': () => `ค่าเริ่มต้นของผู้ดูแลระบบ`,
  'VAViewerSettingsProvider.generalSettings.txt': () => `ธีม`,
  'VAViewerSettingsProvider.enableHighContrast.txt': () => `แทนที่ธีมรายงานและใช้ธีมรายงาน SAS High Contrast`,
  'ViewerBusyDialog.openReport.txt': () => `กำลังเปิดรายงาน…`,
  'ViewerBusyDialog.prepareExport.txt': () => `กำลังเตรียมการส่งออก…`,
  'ViewerBusyDialog.preparePrint.txt': () => `กำลังเตรียมการพิมพ์…`,
  'PDFGeneration.printingReport.txt': () => `กำลังสร้าง PDF รายงาน โดยจะดาวน์โหลดเมื่อพร้อม`,
  'PDFGeneration.fileName.fmt': ({fileName, date}) => `${fileName} เปิด ${date}`,
  'VisualElementActionUtil.actionMenuLabel.txt': () => `เลือกการดำเนินการ`,
  'VisualElementActionUtil.hierarchyExhausted.txt': () => `คุณถึงลำดับชั้นต่ำสุดแล้ว`,
  'VisualElementActionUtil.hierarchiesExhausted.txt': () => `คุณถึงลำดับชั้นต่ำสุดแล้ว`,
  'VisualElementActionUtil.drillLabel.fmt': ({value}) => `เจาะเข้าไปใน ${value}`,
  'SaveImageUtil.snapshot.fmt': ({a0, a1, a2}) => `สแนปช็อตของ ${a0} ${a1} ที่ ${a2}`,
  'ObjectToolbarIcon.SaveImageTooltip.txt': () => `บันทึกภาพ`,
  'ObjectToolbarIcon.PrintObject.txt': () => `พิมพ์วัตถุ…`,
  'ObjectToolbarIcon.ShareObject.txt': () => `แชร์อ็อบเจ็กต์…`,
  'ObjectToolbarIcon.OverflowButton.default.txt': () => `เพิ่มเติม`,
  'ObjectToolbarIcon.OverflowButton.labeled.fmt': ({label}) => `เมนูวัตถุสำหรับ ${label}`,
  'ObjectToolbarIcon.Accelerator.txt': () => `ดูด้วย SAS® Graphics Accelerator`,
  'ZoomControl.button.tip.txt': () => `ซูม`,
  'ZoomControl.button.zoomin.txt': () => `ซูมเข้า`,
  'ZoomControl.button.zoomout.txt': () => `ซูมออก`,
  'ZoomControl.button.display.txt': () => `การควบคุมการขยาย/ย่อ`,
  'ZoomControl.button.reset.txt': () => `รีเซ็ตการขยาย/ย่อ`,
  'ExpandControl.button.expand.txt': () => `ขยายมุมมองใหญ่สุด`,
  'ExpandControl.button.restore.txt': () => `คืนค่ามุมมอง`,
  'ExpandControl.button.expand.tip.txt': () => `ขยายใหญ่สุด`,
  'ExpandControl.button.restore.tip.txt': () => `คืนค่า`,
  'ReportVisualContainer.sectionLink.notAllowed.maximize.txt': () => `ลิงก์ของหน้าไม่สามารถดำเนินการได้ในขณะที่วัตถุนี้ขยายใหญ่สุด`,
  'DragModeControl.button.pan.tip.txt': () => `แพน`,
  'DragModeControl.button.circular.tip.txt': () => `การเลือกรายการแบบวงกลม`,
  'DragModeControl.button.freeform.tip.txt': () => `การเลือกรายการแบบรูปทรงอิสระ`,
  'DragModeControl.button.rectangular.tip.txt': () => `การเลือกรายการแบบสี่เหลี่ยม`,
  'DragModeControl.button.zoom.tip.txt': () => `ขยายเป็นสี่เหลี่ยมมุมฉาก`,
  'ReportXMLDialog.title.txt': () => `รายงาน XML`,
  'ReportXMLDialog.closeButton.txt': () => `ปิด`,
  'ReportXMLDialog.copyButton.txt': () => `คัดลอกไปยังคลิปบอร์ด`,
  'ReportXMLDialog.error.txt': () => `เกิดข้อผิดพลาดในการโหลดรายงาน XML`,
  'ErrorDialog.error.txt': () => `เกิดข้อผิดพลาด โปรดติดต่อผู้ดูแลระบบของคุณ`,
  'Application.banner.txt': () => `SAS® Report Viewer`,
  'Application.wip.banner.txt': () => `SAS® Visual Analytics - โปรแกรมดูรายงาน`,
  'Application.productName.txt': () => `SAS® Visual Analytics`,
  'OpenReportDialog.title.txt': () => `เปิดรายงาน`,
  'OpenReportDialog.reports.txt': () => `รายงาน:`,
  'OpenReportDialog.cancel.txt': () => `ยกเลิก`,
  'OpenReportDialog.ok.txt': () => `ตกลง`,
  'AriaLive.numberOfObjectsUpdated.fmt': ({count}) => `อ็อบเจ็กต์ที่อัปเดตแล้ว ${count} รายการ`,
  'AriaLive.oneObjectUpdated.txt': () => `อ็อบเจ็กต์ที่อัปเดตแล้ว 1 รายการ`,
  'AriaLive.reportOpened.txt': () => `เปิดรายงานแล้ว`,
  'AriaLive.reportClosed.txt': () => `ปิดรายงานแล้ว`,
  'ExportData.generating.txt': () => `สร้างการส่งออก จะดาวน์โหลดเมื่อพร้อม`,
  'ExportData.warning.txt': () => `เกิดข้อผิดพลาดในการสร้างข้อมูล`,
  'ExportData.nodata.txt': () => `ไม่มีข้อมูลที่จะส่งออก`,
  'ExportData.exportData.txt': () => `ส่งออกข้อมูล…`,
  'PlaybackAnimationDialog.saveButton.txt': () => `บันทึก`,
  'PlaybackAnimationDialog.cancelButton.txt': () => `ยกเลิก`,
  'PlaybackAnimationDialog.playButton.txt': () => `รายงานการเล่น`,
  'PlaybackAnimationDialog.title.txt': () => `แก้ไขการเล่น`,
  'PlaybackAnimationDialog.transitionUnit.label.txt': () => `หน่วยการเปลี่ยน:`,
  'PlaybackAnimationDialog.transitionUnit.page.txt': () => `หน้า`,
  'PlaybackAnimationDialog.transitionUnit.object.txt': () => `วัตถุ`,
  'PlaybackAnimationDialog.secondsPerUnit.label.txt': () => `วินาทีต่อหน่วย:`,
  'PlaybackAnimationDialog.showMaximized.label.txt': () => `แสดงวัตถุที่มีขนาดใหญ่ที่สุด:`,
  'PlaybackAnimationDialog.showCanvasOnly.label.txt': () => `แสดงแคนวาสเท่านั้น:`,
  'PlaybackAnimationDialog.showTimer.label.txt': () => `แสดงตัวตั้งเวลา:`,
  'PlaybackAnimationDialog.showNavigationControls.label.txt': () => `แสดงการควบคุมการนำทางเมื่อคลิกหรือสัมผัส:`,
  'PlaybackNavigationControls.previousPage.txt': () => `หน้าก่อนหน้านี้`,
  'PlaybackNavigationControls.nextPage.txt': () => `หน้าถัดไป`,
  'PlaybackNavigationControls.previousObject.txt': () => `อ็อบเจ็กต์ก่อนหน้านี้`,
  'PlaybackNavigationControls.nextObject.txt': () => `อ็อบเจ็กต์ถัดไป`,
  'TransportConnection.generateReportTimeout.txt': () => `ใช้เวลาในการโหลดรายงานนาน คุณต้องการดำเนินการต่อหรือไม่`,
  'TransportConnection.openReport.txt': () => `เปิดรายงาน`,
  'ViewerContainer.reportNotFound.fmt': ({location}) => `ไม่มีรายงานที่ระบุในที่ตั้งต่อไปนี้: ${location}`,
  'Hierarchy.expand.fmt': ({label}) => `ขยาย ${label}`,
  'Hierarchy.collapse.fmt': ({label}) => `ยุบ ${label}`,
  'GraphElementDecorator.overview.txt': () => `ภาพรวม`,
  'GraphElementDecorator.layers.txt': () => `ซ่อนหรือแสดงชั้น`,
  'CompositeGraphElementDecorator.hideOverview.txt': () => `ซ่อนภาพรวม`,
  'CompositeGraphElementDecorator.showOverview.txt': () => `แสดงภาพรวม`,
  'TitleInfoButton.tooltip.txt': () => `ข้อมูล`,
  'SectionSelectionBar.noSelections.txt': () => `ไม่มีรายการที่เลือก`,
  'SectionSelectionBar.title.txt': () => `ตัวกรอง:`,
  'CheckboxList.selectAll.txt': () => `เลือกทั้งหมด`,
  'CheckboxList.clearSelection.txt': () => `ล้างการเลือก`,
  'CheckboxList.clearSelection.fmt': ({count}) => `ลบรายการที่เลือก (${count})`,
  'ExplanationInfoDialog.title.fmt': ({label}) => `การอธิบาย ${label}`,
  'ExplanationInfoDialog.loading.txt': () => `กำลังเตรียมคำอธิบาย ...`,
  'ExplanationInfoDialog.cancel.txt': () => `ยกเลิก`,
  'ExplanationInfoDialog.close.txt': () => `ปิด`,
  'PromptHeader.emptyReport.txt': () => `ลากรายการข้อมูลหรือตัวควบคุมมาที่นี่เพื่อสร้างพร้อมท์รายงาน`,
  'PromptHeader.emptyPage.txt': () => `ลากรายการข้อมูลหรือตัวควบคุมมาที่นี่เพื่อสร้างพร้อมท์หน้า`,
  'PromptHeader.collapsePageControlArea.txt': () => `ยุบพื้นที่ควบคุมหน้า`,
  'PromptHeader.expandPageControlArea.txt': () => `ขยายพื้นที่ควบคุมหน้า`,
  'PromptHeader.collapseReportControlArea.txt': () => `ยุบพื้นที่ควบคุมรายงาน`,
  'PromptHeader.expandReportControlArea.txt': () => `ขยายพื้นที่ควบคุมรายงาน`,
  'PromptHeader.collapseControlArea.txt': () => `ยุบพื้นที่ควบคุม`,
  'PromptHeader.expandControlArea.txt': () => `ขยายพื้นที่ควบคุม`,
  'PromptHeader.reportControlArea.txt': () => `พื้นที่ควบคุมรายงาน`,
  'PromptHeader.allControlAreas.txt': () => `พื้นที่ควบคุมทั้งหมด`,
  'PromptHeader.pageControlArea.txt': () => `พื้นที่ควบคุมหน้า`,
  'ZeroState.editMode.txt': () => `ลากเทมเพลต รายการข้อมูล หรืออ็อบเจ็กต์ที่นี่`,
  'ZeroState.viewMode.txt': () => `ไม่มีเนื้อหาที่จะแสดง`,
  'ObjectStatus.assignData.txt': () => `กำหนดข้อมูล`,
  'ObjectStatus.selectImage.txt': () => `เลือกภาพ`,
  'ObjectStatus.selectJob.txt': () => `เลือกงาน`,
  'ObjectStatus.cancelLoading.txt': () => `ยกเลิกการโหลด`,
  'ObjectStatus.loadingCanceled.txt': () => `การโหลดยกเลิกแล้ว`,
  'ObjectStatus.resumeLoading.txt': () => `ทำการโหลดต่อ`,
  'ObjectStatus.refresh.txt': () => `รีเฟรช`,
  'ObjectStatus.setJobParameters.txt': () => `ตั้งค่าพารามิเตอร์`,
  'ObjectSearch.title.txt': () => `การค้นหาทางภูมิศาสตร์`,
  'ObjectSearch.pin.txt': () => `การปักหมุด`,
  'ObjectSearch.unpin.txt': () => `ถอนหมุด`,
  'MainSearchPanel.searchHints.txt': () => `คำแนะนำการค้นหา`,
  'MainSearchPanel.searchResults.txt': () => `ผลการค้นหา`,
  'MainSearchPanel.features.txt': () => `คุณสมบัติ`,
  'MainSearchPanel.pin.txt': () => `การปักหมุดใหม่`,
  'MainSearchPanel.pin.tooltip.txt': () => `การปักหมุดใหม่`,
  'MainSearchPanel.route.txt': () => `เส้นทางใหม่`,
  'MainSearchPanel.route.tooltip.txt': () => `เส้นทางใหม่`,
  'MainSearchPanel.geographicArea.txt': () => `พื้นที่ทางภูมิศาสตร์ใหม่`,
  'MainSearchPanel.geographicArea.tooltip.txt': () => `พื้นที่ทางภูมิศาสตร์ใหม่`,
  'MainSearchPanel.newMyLocationPin.txt': () => `การปักหมุดตำแหน่งของฉัน`,
  'MainSearchPanel.myLocationPin.txt': () => `ตำแหน่งที่ตั้งของฉัน`,
  'MainSearchPanel.show.txt': () => `แสดง`,
  'MainSearchPanel.show.all.txt': () => `แสดงทั้งหมด`,
  'MainSearchPanel.hide.txt': () => `ซ่อน`,
  'MainSearchPanel.hide.all.txt': () => `ซ่อนทั้งหมด`,
  'MainSearchPanel.delete.txt': () => `ลบ`,
  'MainSearchPanel.delete.all.txt': () => `ลบทั้งหมด`,
  'MainSearchPanel.convert.txt': () => `แปลงผลการค้นหาเป็นการปักหมุด`,
  'MainSearchPanel.convert.all.txt': () => `แปลงผลการค้นหาทั้งหมดเป็นการปักหมุด`,
  'MainSearchPanel.showPinLabels.txt': () => `แสดงป้ายกำกับการปักหมุด`,
  'MainSearchPanel.close.label.txt': () => `การค้นหาทางภูมิศาสตร์`,
  'MainSearchPanel.navigate.tooltip.txt': () => `แสดงรายละเอียด`,
  'MainSearchPanel.demographics.tooltip.txt': () => `สถิติทางประชากรศาสตร์`,
  'PanelHeader.back.tooltip.txt': () => `ย้อนกลับ`,
  'GeographicAreaPanel.title.txt': () => `พื้นที่ทางภูมิศาสตร์`,
  'GeographicAreaPanel.draw.txt': () => `วาดพื้นที่`,
  'GeographicAreaPanel.update.txt': () => `อัปเดตพื้นที่`,
  'GeographicAreaPanel.label.txt': () => `ป้ายกำกับ:`,
  'GeographicAreaPanel.location.txt': () => `สถานที่:`,
  'GeographicAreaPanel.distance.miles.txt': () => `ระยะทาง (ไมล์):`,
  'GeographicAreaPanel.distance.kilometer.txt': () => `ระยะทาง (กม.):`,
  'GeographicAreaPanel.distance.add.txt': () => `เพิ่มระยะทาง`,
  'GeographicAreaPanel.time.add.txt': () => `เพิ่มเวลา`,
  'GeographicAreaPanel.distance.delete.txt': () => `ลบระยะทาง`,
  'GeographicAreaPanel.time.minutes.txt': () => `เวลา (นาที):`,
  'GeographicAreaPanel.duration.txt': () => `ระยะเวลา:`,
  'GeographicAreaPanel.distanceUnits.miles.txt': () => `ไมล์`,
  'GeographicAreaPanel.distanceUnits.kilometers.txt': () => `กิโลเมตร`,
  'GeographicAreaPanel.menu.clear.txt': () => `ล้างพื้นที่ทางภูมิศาสตร์`,
  'GeographicAreaPanel.menu.link.txt': () => `เชื่อมโยงที่อยู่กับองค์ประกอบข้อมูลและปักหมุดตามค่าเริ่มต้น`,
  'GeographicAreaPanel.menu.unlink.txt': () => `ถอดการเชื่อมโยงที่อยู่พื้นที่ทางภูมิศาสตร์`,
  'GeographicAreaPanel.menu.delete.txt': () => `ลบพื้นที่ทางภูมิศาสตร์`,
  'GeographicAreaPanel.demographics.txt': () => `สถิติทางประชากรศาสตร์`,
  'GeographicAreaPanel.demographics.set.txt': () => `แสดงสถิติทางประชากร`,
  'GeographicAreaPanel.demographics.menu.expand.txt': () => `ขยายมุมมอง`,
  'GeographicAreaPanel.demographics.menu.edit.txt': () => `แก้ไขสถิติทางประชากรศาสตร์`,
  'GeographicAreaPanel.demographics.menu.delete.txt': () => `ลบสถิติทางประชากรศาสตร์`,
  'GeographicAreaPanel.demographics.expired.txt': () => `จะต้องโหลดข้อมูลสถิติทางประชากรศาสตร์ใหม่`,
  'GeographicAreaPanel.demographics.reload.txt': () => `โหลดสถิติทางประชากรศาสตร์ใหม่`,
  'GeographicAreaPanel.invalid.location.txt': () => `พื้นที่ทางภูมิศาสตร์มีตำแหน่งที่ตั้งที่ไม่ถูกต้องและไม่สามารถสร้าง`,
  'TravelTypeField.dateselector.tooltip.txt': () => `เลือกวันและเวลา`,
  'TravelTypeField.cancel.txt': () => `ยกเลิก`,
  'TravelTypeField.ok.txt': () => `ตกลง`,
  'TravelTypeField.button.tooltip.txt': () => `เลือกวันและเวลา`,
  'TravelTypeField.day.txt': () => `วัน:`,
  'TravelTypeField.time.txt': () => `เวลา:`,
  'TravelTypeField.distanceTypes.direct.txt': () => `โดยตรง`,
  'TravelTypeField.distanceTypes.distance.txt': () => `ระยะทาง`,
  'TravelTypeField.travelType.txt': () => `ประเภทการเดินทาง:`,
  'TravelTypeField.traffic.txt': () => `ใส่การจราจร:`,
  'TravelTypeField.traffic.offset.txt': () => `ออฟเซ็ตเวลาการจราจร:`,
  'TravelTypeField.traffic.daytime.txt': () => `วันและเวลาของการจราจร:`,
  'TravelTypeField.distanceTypes.distance.unit.txt': () => `หน่วยระยะทาง`,
  'TravelTypeField.distanceTypes.driving.distance.txt': () => `ระยะทางการขับขี่`,
  'TravelTypeField.distanceTypes.driving.time.txt': () => `เวลาการขับขี่`,
  'TravelTypeField.distanceTypes.trucking.distance.txt': () => `ระยะทางการขนส่ง`,
  'TravelTypeField.distanceTypes.trucking.time.txt': () => `เวลาการขนส่ง`,
  'TravelTypeField.distanceTypes.walking.distance.txt': () => `ระยะทางการเดิน`,
  'TravelTypeField.distanceTypes.walking.time.txt': () => `เวลาการเดิน`,
  'TravelTypeField.driveTimeTrafficTypes.none.txt': () => `ไม่ใช่`,
  'TravelTypeField.driveTimeTrafficTypes.live.txt': () => `การจราจรปัจจุบัน`,
  'TravelTypeField.driveTimeTrafficTypes.historic.txt': () => `การจราจรทั่วไป`,
  'TravelTypeField.driveTimeTraffic.offset.fmt': ({hour}) => `${hour} ชม.`,
  'TravelTypeField.driveTimeTraffic.update.refresh.txt': () => `อัปเดตการจราจรสำหรับคุณสมบัตินี้`,
  'TravelTypeField.driveTimeTraffic.update.refreshAll.txt': () => `อัปเดตการจราจรสำหรับคุณสมบัติทั้งหมด`,
  'TravelTypeField.driveTimeTraffic.update.tooltip.txt': () => `อัปเดตข้อมูลการจราขร`,
  'RoutePanel.title.txt': () => `เส้นทาง`,
  'RoutePanel.draw.txt': () => `วาดเส้นทาง`,
  'RoutePanel.update.txt': () => `อัปเดตเส้นทาง`,
  'RoutePanel.label.txt': () => `ป้ายกำกับ:`,
  'RoutePanel.locations.txt': () => `ตำแหน่งที่ตั้ง`,
  'RoutePanel.menu.clear.txt': () => `ล้างเส้นทาง`,
  'RoutePanel.menu.reverse.txt': () => `ย้อนกลับเส้นทาง`,
  'RoutePanel.menu.add.waypoint.txt': () => `เพิ่มตำแหน่งที่ตั้งเส้นทาง`,
  'RoutePanel.menu.delete.waypoint.txt': () => `ลบตำแหน่งที่ตั้งเส้นทาง`,
  'RoutePanel.menu.unlink.txt': () => `ยกเลิกเชื่อมโยงตำแหน่งที่ตั้งเส้นทาง`,
  'RoutePanel.menu.arrows.txt': () => `ลูกศรเส้นทาง`,
  'RoutePanel.menu.arrows.hide.txt': () => `ซ่อนลูกศรเส้นทาง`,
  'RoutePanel.menu.arrows.show.txt': () => `แสดงลูกศรเส้นทาง`,
  'RoutePanel.menu.arrows.oneway.txt': () => `ทางเดียว`,
  'RoutePanel.menu.arrows.twoway.txt': () => `สองทาง`,
  'RoutePanel.menu.delete.txt': () => `ลบเส้นทาง`,
  'RoutePanel.route.width.txt': () => `ความกว้างเส้นทาง`,
  'RoutePanel.distance.txt': () => `ระยะทาง:`,
  'RoutePanel.distance.miles.fmt': ({distance}) => `${distance} ไมล์`,
  'RoutePanel.distance.kilometers.fmt': ({distance}) => `${distance} กม.`,
  'RoutePanel.location.add.txt': () => `เพิ่มตำแหน่งที่ตั้ง`,
  'RoutePanel.location.delete.txt': () => `ลบตำแหน่งที่ตั้ง`,
  'RoutePanel.duration.txt': () => `เวลา:`,
  'RoutePanel.invalid.location.txt': () => `เส้นทางมีตำแหน่งที่ตั้งไม่ถูกต้องและไม่สามารถสร้าง`,
  'RoutePanel.accessibilityCellInfo.fmt': ({index, location}) => `ตำแหน่งที่ตั้ง ${index}, ${location}, อินพุต`,
  'PinPanel.pinTitle.txt': () => `การปักหมุด`,
  'PinPanel.addDescription.txt': () => `เพิ่มคำอธิบาย`,
  'PinPanel.deleteDescription.txt': () => `ลบคำอธิบาย`,
  'PinPanel.newPin.txt': () => `การปักหมุดใหม่ที่ตำแหน่งนี้`,
  'PinPanel.deletePin.txt': () => `ลบการปักหมุด`,
  'PinPanel.linkPins.txt': () => `เชื่อมโยงการปักหมุดกับองค์ประกอบข้อมูลตามค่าเริ่มต้น`,
  'PinPanel.unlinkAllItems.txt': () => `เลิกเชื่อมโยงทุกรายการ`,
  'PinPanel.unlinkItems.txt': () => `เลิกเชื่อมโยงรายการ`,
  'PinPanel.label.txt': () => `ป้ายกำกับ:`,
  'PinPanel.location.txt': () => `สถานที่:`,
  'PinPanel.description.txt': () => `คำอธิบาย:`,
  'PinPanel.linked.txt': () => `เชื่อมโยงแล้ว`,
  'PinPanel.searchClickPlaceholder.txt': () => `ค้นหาหรือเลือกบนแผนที่`,
  'PinPanel.searchPlaceholder.txt': () => `ค้นหา`,
  'PinPanel.addRoute.txt': () => `เพิ่มเส้นทาง`,
  'PinPanel.addRoute.tooltip.txt': () => `เพิ่มเส้นทาง`,
  'PinPanel.addArea.txt': () => `เพิ่มพื้นที่ทางภูมิศาสตร์`,
  'PinPanel.addArea.tooltip.txt': () => `เพิ่มพื้นที่ทางภูมิศาสตร์`,
  'PinPanel.addArea.title.txt': () => `เพิ่มพื้นที่ทางภูมิศาสตร์`,
  'PinPanel.myLocationTitle.txt': () => `การปักหมุดตำแหน่งของฉัน`,
  'PinPanel.deleteMyLocationPin.txt': () => `ลบการปักหมุดตำแหน่งของฉัน`,
  'PinPanel.enableAutoUpdate.txt': () => `เปิดใช้งานการอัปเดตอัตโนมัติตำแหน่งของฉัน`,
  'PinPanel.disableAutoUpdate.txt': () => `ปิดใช้งานการอัปเดตอัตโนมัติตำแหน่งของฉัน`,
  'PinPanel.editAutoRefreshInterval.txt': () => `แก้ไขช่วงการรีเฟรชอัตโนมัติตำแหน่งของฉัน...`,
  'PinPanel.linkToPin.txt': () => `เชื่อมโยงเพื่อปักหมุด`,
  'PinPanel.useCurrentLocation.txt': () => `ใช้ตำแหน่งที่ตั้งปัจจุบันเพื่อปักหมุด`,
  'PinPanel.notDrawn.txt': () => `ไม่ได้วาด`,
  'PinPanel.undetermined.txt': () => `ยังไม่ได้กำหนด`,
  'PinPanel.findMyLocation.txt': () => `ค้นหาตำแหน่งที่ตั้งของฉัน`,
  'PinPanel.cannotDetermineLocation.txt': () => `แอปพลิเคชันไม่สามารถระบุตำแหน่งที่ตั้งปัจจุบันของคุณ ถ้าคุณต้องการแบ่งปันตำแหน่งที่ตั้งของคุณ ดูที่วิธีใช้สำหรับเบราว์เซอร์หรืออุปกรณ์ของคุณ`,
  'PinPanel.autoRefreshInterval.txt': () => `ช่วงการรีเฟรชอัตโนมัติตำแหน่งที่ตั้งของฉัน`,
  'PinPanel.interval.hours.txt': () => `ชั่วโมง:`,
  'PinPanel.interval.minutes.txt': () => `นาที:`,
  'PinPanel.interval.seconds.txt': () => `วินาที:`,
  'PinPanel.invalid.location.txt': () => `การปักหมุดมีตำแหน่งที่ตั้งไม่ถูกต้องและไม่สามารถสร้าง`,
  'PinPanel.description.miles.1.fmt': ({value1}) => `${value1} ไมล์`,
  'PinPanel.description.miles.2.fmt': ({value1, value2}) => `${value1}, ${value2} ไมล์`,
  'PinPanel.description.miles.3.fmt': ({value1, value2, value3}) => `${value1}, ${value2}, ${value3} ไมล์`,
  'PinPanel.description.kilometers.1.fmt': ({value1}) => `${value1} กม.`,
  'PinPanel.description.kilometers.2.fmt': ({value1, value2}) => `${value1}, ${value2} กม.`,
  'PinPanel.description.kilometers.3.fmt': ({value1, value2, value3}) => `${value1}, ${value2}, ${value3} กม.`,
  'PinPanel.description.minutes.1.fmt': ({value1}) => `${value1} ต่ำสุด`,
  'PinPanel.description.minutes.2.fmt': ({value1, value2}) => `${value1}, ${value2} ต่ำสุด`,
  'PinPanel.description.minutes.3.fmt': ({value1, value2, value3}) => `${value1}, ${value2}, ${value3} ต่ำสุด`,
  'PinPanel.clearLocation.tooltip.txt': () => `ล้างข้อความบอกตำแหน่ง`,
  'DiscardChangesDialog.title.area.txt': () => `พื้นที่ทางภูมิศาสตร์`,
  'DiscardChangesDialog.title.route.txt': () => `เส้นทาง`,
  'DiscardChangesDialog.text.area.txt': ({label}) => `คุณได้ทำการเปลี่ยนแปลงพื้นที่ทางภูมิศาสตร์แต่ไม่ได้วาดพื้นที่ใหม่\n\nคุณต้องการยกเลิกการเปลี่ยนแปลงกับ ${label} หรือไม่`,
  'DiscardChangesDialog.text.route.txt': ({label}) => `คุณได้ทำการเปลี่ยนแปลงเส้นทางทางภูมิศาสตร์แต่ไม่ได้วาดเส้นทางที่ใหม่\n\nคุณต้องการยกเลิกการเปลี่ยนแปลงกับ ${label} หรือไม่`,
  'DiscardChangesDialog.discard.txt': () => `ละทิ้ง`,
  'DiscardChangesDialog.cancel.txt': () => `ยกเลิก`,
  'FeatureErrorDialog.title.area.txt': () => `วาดพื้นที่ทางภูมิศาสตร์`,
  'FeatureErrorDialog.title.route.txt': () => `วาดเส้นทาง`,
  'FeatureErrorDialog.text.area.txt': () => `ไม่สามารถวาดพื้นที่ทางภูมิศาสตร์\n\nเคล็ดลับ: ถ้าตำแหน่งที่ตั้งของพื้นที่ของคุณไม่มีโครงสร้างพื้นฐานการเดินทาง เช่น ถนน อาจจะไม่สามารถคำนวณพื้นที่ทางภูมิศาสตร์ได้ ให้ใช้ประเภทการเดินทางตามระยะทางแทน หรือย้ายพื้นที่ไปยังตำแหน่งที่ตั้งที่มีโครงสร้างพื้นฐานการเดินทาง`,
  'FeatureErrorDialog.text.route.txt': () => `ไม่สามารถวาดเส้นทาง\n\nเคล็ดลับ: ถ้าตำแหน่งที่ตั้งของเส้นทางของคุณไม่มีโครงสร้างพื้นฐานการเดินทาง เช่น ถนน อาจจะไม่สามารถคำนวณเส้นทางได้ ให้ใช้ประเภทการเดินทางตามระยะทางแทน หรือย้ายเส้นทางไปยังตำแหน่งที่ตั้งที่มีโครงสร้างพื้นฐานการเดินทาง`,
  'FeatureErrorDialog.close.txt': () => `ปิด`,
  'DemographicsSelectorDialog.title.txt': () => `แสดงสถิติทางประชากร`,
  'DemographicsSelectorDialog.cancel.txt': () => `ยกเลิก`,
  'DemographicsSelectorDialog.ok.txt': () => `ตกลง`,
  'DemographicsSelectorDialog.country.txt': () => `ประเทศ/ภูมิภาค`,
  'DemographicsSelectorDialog.tab.basic.txt': () => `พื้นฐาน`,
  'DemographicsSelectorDialog.tab.advanced.txt': () => `ขั้นสูง`,
  'DemographicsSelectorDialog.tab.recent.txt': () => `ล่าสุด`,
  'DemographicsSelectorDialog.categories.txt': () => `หมวดหมู่`,
  'DemographicsSelectorDialog.category.income.txt': () => `รายได้`,
  'DemographicsSelectorDialog.category.age.txt': () => `อายุ`,
  'DemographicsSelectorDialog.category.households.txt': () => `ครอบครัว`,
  'DemographicsSelectorDialog.category.housing.txt': () => `การเคหะ`,
  'DemographicsSelectorDialog.category.maritalstatus.txt': () => `สถานภาพการสมรส`,
  'DemographicsSelectorDialog.category.population.txt': () => `ประชากร`,
  'DemographicsSelectorDialog.category.usergroup.txt': () => `กลุ่มผู้ใช้งาน`,
  'DemographicsSelectorDialog.category.health.txt': () => `สุขภาพ`,
  'DemographicsSelectorDialog.category.education.txt': () => `การศึกษา`,
  'DemographicsSelectorDialog.category.business.txt': () => `ธุรกิจ`,
  'DemographicsSelectorDialog.category.race.txt': () => `เชื้อชาติ`,
  'DemographicsSelectorDialog.category.spending.txt': () => `การใช้จ่าย`,
  'DemographicsSelectorDialog.category.behaviors.txt': () => `พฤติกรรม`,
  'DemographicsSelectorDialog.category.jobs.txt': () => `งาน`,
  'DemographicsSelectorDialog.category.poverty.txt': () => `ความจน`,
  'DemographicsSelectorDialog.category.tapestry.txt': () => `พรมผนัง`,
  'DemographicsSelectorDialog.category.atrisk.txt': () => `อยู่ในความเสี่ยง`,
  'DemographicsSelectorDialog.category.keyfacts.txt': () => `ปัจจัยสำคัญ`,
  'DemographicsSelectorDialog.category.supplyanddemand.txt': () => `อุปทานและอุปสงค์`,
  'DemographicsSelectorDialog.category.policy.txt': () => `นโยบาย`,
  'DemographicsSelectorDialog.category.landscape.txt': () => `แนวนอน`,
  'DemographicsSelectorDialog.category.crime.txt': () => `อาชญากรรม`,
  'ManageColumns.title.txt': () => `จัดการคอลัมน์`,
  'ManageColumns.ok.txt': () => `ตกลง`,
  'ManageColumns.cancel.txt': () => `ยกเลิก`,
  'ManageColumns.hiddenColumns.txt': () => `คอลัมน์ที่ซ่อน`,
  'ManageColumns.displayedColumns.txt': () => `คอลัมน์ที่แสดง`,
  'SearchResultPanel.title.txt': () => `ผลการค้นหา`,
  'SearchResultPanel.menu.delete.txt': () => `ลบผลการค้นหา`,
  'SearchResultPanel.convert.txt': () => `แปลงเป็นปักหมุด`,
  'SearchResultPanel.convert.tooltip.txt': () => `แปลงเป็นปักหมุด`,
  'DemographicsResultsDialog.title.txt': () => `สถิติทางประชากรศาสตร์`,
  'DemographicsResultsDialog.cancel.txt': () => `ยกเลิก`,
  'DemographicsResultsDialog.close.txt': () => `ปิด`,
  'DemographicsResultsDialog.edit.txt': () => `แก้ไข`,
  'DemographicsResultsDialog.layout.page.txt': () => `มุมมองตัวหมุน`,
  'DemographicsResultsDialog.layout.list.txt': () => `มุมมองคอลัมน์เดียว`,
  'DemographicsResultsDialog.layout.tile.txt': () => `มุมมองไทล์`,
  'DemographicsResultsDialog.noData.txt': () => `ไม่มีข้อมูลที่ตรงกับพื้นที่ทางภูมิศาสตร์ปัจจุบัน`,
  'PinsAtSameLocationPanel.title.txt': () => `ปักหมุดที่ตำแหน่งที่ตั้งเดียวกัน`,
  'PinsAtSameLocationPanel.searchResults.txt': () => `ผลการค้นหา`,
  'PinsAtSameLocationPanel.pins.txt': () => `การปักหมุด`,
  'PinsAtSameLocationPanel.showAll.txt': () => `แสดงทั้งหมด`,
  'PinsAtSameLocationPanel.hideAll.txt': () => `ซ่อนทั้งหมด`,
  'PinsAtSameLocationPanel.deleteAll.txt': () => `ลบทั้งหมด`,
  'PinsAtSameLocationPanel.show.txt': () => `แสดง`,
  'PinsAtSameLocationPanel.hide.txt': () => `ซ่อน`,
  'PinsAtSameLocationPanel.delete.txt': () => `ลบ`,
  'LocationPopover.pin.title.txt': () => `ปักหมุดตำแหน่งที่ตั้ง`,
  'LocationPopover.area.title.txt': () => `ตำแหน่งที่ตั้งพื้นที่ทางภูมิศาสตร์`,
  'LocationPopover.route.title.txt': ({label}) => `ตำแหน่งที่ตั้งเส้นทาง ${label}`,
  'LocationPopover.name.txt': () => `ชื่อ`,
  'LocationPopover.location.txt': () => `สถานที่:`,
  'LocationPopover.ok.txt': () => `ตั้งค่าตำแหน่งที่ตั้ง`,
  'LocationPopover.cancel.txt': () => `ออกจากโหมดการเลือก`,
  'LocationPopover.hint.txt': () => `คลิกที่แผนที่อีกครั้งเพื่อระบุตำแหน่งที่ตั้งอื่น`,
  'TreeDualSelector.source.default.txt': () => `รายการที่พร้อมใช้งาน`,
  'TreeDualSelector.target.default.txt': () => `รายการที่เลือกไว้`,
  'TreeDualSelector.filtered.length.fmt': ({label, filteredLength, totalLength}) => `${label} (${filteredLength} ของ ${totalLength}):`,
  'TreeDualSelector.item.length.fmt': ({label, length}) => `${label} (${length}):`,
  'TreeDualSelector.emptymessage.txt': () => `ไม่มีรายการ`,
  'TreeDualSelector.filter.placeholder.txt': () => `ตัวกรอง`,
  'TreeDualSelector.customItem.choiceIcon.tooltip.txt': () => `รายการแบบกำหนดเอง`,
  'TreeDualSelector.afterAction.add.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} รายการถูกเพิ่มแล้ว`,
  'TreeDualSelector.afterAction.remove.fmt': ({noOfSelectedRows}) => `${noOfSelectedRows} รายการที่นำออกแล้ว`,
  'TreeDualSelector.afterAction.addAll.txt': () => `รายการทั้งหมดถูกเพิ่ม`,
  'TreeDualSelector.afterAction.removeAll.txt': () => `รายการทั้งหมดถูกนำออก`,
  'TreeDualSelector.afterAction.up.txt': () => `ถูกเลื่อนขึ้น`,
  'TreeDualSelector.afterAction.down.txt': () => `ถูกเลื่อนลง`,
  'TreeDualSelector.afterAction.top.txt': () => `ถูกเลื่อนไปยังด้านบน`,
  'TreeDualSelector.afterAction.bottom.txt': () => `ถูกเลื่อนไปยังด้านล่าง`,
  'TreeDualSelector.afterAction.undo.add.txt': () => `เพิ่มการดำเนินการที่แปลงกลับแล้ว`,
  'TreeDualSelector.afterAction.undo.remove.txt': () => `เอาการดำเนินการที่แปลงกลับแล้วออก`,
  'TreeDualSelector.afterAction.customAdd.txt': () => `รายการแบบกำหนดเองถูกเพิ่ม`,
  'TreeDualSelector.customItemSelection.fmt': ({customItemSelected}) => `${customItemSelected} รายการแบบกำหนดเองถูกเลือก`,
  'TreeDualSelector.itemSelectionWithDescription.fmt': ({itemSelected, itemDescription}) => `${itemSelected} ${itemDescription} เลือกแล้ว`,
  'TreeDualSelector.itemSelection.fmt': ({itemSelected}) => `${itemSelected} เลือกแล้ว`,
  'TreeDualSelector.reorderButton.up.button.aria': ({targetListLabel}) => `เลื่อนขึ้นหนึ่งแถวใน ${targetListLabel}`,
  'TreeDualSelector.reorderButton.down.button.aria': ({targetListLabel}) => `เลื่อนลงหนึ่งแถวใน ${targetListLabel}`,
  'TreeDualSelector.reorderButton.top.button.aria': ({targetListLabel}) => `เลื่อนไปยังด้านบนของ ${targetListLabel}`,
  'TreeDualSelector.reorderButton.bottom.button.aria': ({targetListLabel}) => `เลื่อนไปยังด้านล่างของ ${targetListLabel}`,
  'TreeDualSelector.moveButton.add.button.aria': ({targetListLabel}) => `เพิ่มรายการไปยัง ${targetListLabel}`,
  'TreeDualSelector.moveButton.addall.button.aria': ({targetListLabel}) => `เพิ่มทั้งหมดไปยัง ${targetListLabel}`,
  'TreeDualSelector.moveButton.remove.button.aria': ({targetListLabel}) => `นำรายการออกจาก ${targetListLabel}`,
  'TreeDualSelector.moveButton.removeall.button.aria': ({targetListLabel}) => `ลบทั้งหมดออกจาก ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoadd.button.aria': ({targetListLabel}) => `เลิกทำการเพิ่มสำหรับ ${targetListLabel}`,
  'TreeDualSelector.moveButton.undoremove.button.aria': ({targetListLabel}) => `เลิกทำการลบสำหรับ ${targetListLabel}`,
  'TreeDualSelector.searchField.aria': ({listLabel}) => `ตัวกรอง ${listLabel}`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.title': () => `ลบ`,
  'TreeDualSelector.moveButton.removeButton.warningDialog.txt': () => `รายการแบบกำหนดเองใดๆ ที่คุณได้เลือกสำหรับการลบจะถูกลบอย่างถาวรถ้าคุณดำเนินการต่อ\n\n คุณต้องการดำเนินการต่อหรือไม่`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.title': () => `ลบรายการทั้งหมด`,
  'TreeDualSelector.moveButton.removeAllButton.warningDialog.txt': () => `รายการแบบกำหนดเองในรายการนี้จะถูกลบอย่างถาวรถ้าคุณดำเนินการต่อ\n\n คุณต้องการดำเนินการต่อหรือไม่`,
  'LinkNavigator.backButton.label': () => `ย้อนกลับ`,
  'LinkNavigator.rootOrReportLinkBreadcrumb.label': ({reportLabel, sectionLabel}) => `${reportLabel}: ${sectionLabel}`,
  'LinkNavigator.incomingFilters.title': () => `ตัวกรองขาเข้า`,
  'LinkNavigator.reportLevel.label': () => `ระดับรายงาน`,
  'LinkNavigator.sectionLevel.label': () => `ระดับหน้า`,
  'ReportSectionZeroState.heading.label': () => `ออกแบบรายงาน`,
  'ReportSectionZeroState.description.label': () => `ลากวัตถุ หรือรายการข้อมูลลงบนหน้า หรือเลือกตัวเลือกด้านล่าง`,
  'ReportSectionZeroState.hideAutoChartButton.description.label': () => `ลากออบเจ็กต์ หรือรายการข้อมูลลงบนหน้า หรือเริ่มจากเทมเพลตหน้า`,
  'ReportSectionZeroState.autoChartButton.label': () => `สร้างออบเจ็กต์`,
  'ReportSectionZeroState.selectTemplateButton.label': () => `เลือกเทมเพลต`,
  'ReportSectionZeroState.exploreSuggestions.label': () => `สำรวจข้อเสนอแนะ`,
  'PromptContainerTooltip.noSelections.txt': () => `ไม่มีรายการที่เลือก`,
  'PromptContainerTooltip.selectedValues.txt': () => `ค่าที่เลือกไว้`,
}
export default localizers;
